import React from 'react';
import type { SubscriptionBrief } from '../../store/auth';

/** "Faol — 12 kun qoldi" / "Tugagan" — qisqa holat matni. */
export const SubscriptionBadge: React.FC<{ subscription: SubscriptionBrief }> = ({ subscription }) => {
  if (!subscription.active) {
    return <div className="text-sm font-medium text-danger-600">Muddati tugagan</div>;
  }
  const soon = subscription.days_left <= 3;
  return (
    <div className={`text-sm ${soon ? 'text-warning-700 font-medium' : 'text-gray-500'}`}>
      Faol — {subscription.days_left} kun qoldi
    </div>
  );
};
